import { AppLink } from '@crm/components'
import { PropsWithChildren } from 'react'

type Props = {
  condition: boolean
  path: string
} & PropsWithChildren

export const ConditionalLink = ({ children, condition, path }: Props) =>
  condition ? <AppLink to={path}>{children}</AppLink> : children
